import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../common/customHttp.service';
import { ApiUrl } from '../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../layout/layout.component';
import { UnitsModel } from '../../common/viewModels/GlobalRegistry/UnitsModel';
import { ToastrService } from 'ngx-toastr';
import { PagerService } from '../../common/pagerService';
import { TestMethodModel } from '../../common/viewModels/ReportConfig/productgradesModel';
import { ValidationService } from '../../common/validationservice';
declare var $: any;

@Component({
    selector: 'testmethods',
    templateUrl: './testmethods.component.html',
    styleUrls: ['./testmethods.component.scss']
})
export class TestMethodsComponent implements OnInit {

    units: UnitsModel[];
    testMethodsForm: FormGroup;
    testMethodsSearchForm: FormGroup;
    searchFields: TestMethodModel = new TestMethodModel();
    isNoRecords: boolean = true;
    pager: any = {};
    pagedItems: any[];
    length: number = 0;
    id: number;
    isSubmitted: boolean = false;
    mainComponent:any;
    constructor(public _router: Router, private _formBuilder: FormBuilder,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute,
        private _mApp: MainAppComponent, private _toaster: ToastrService,
        private _pageSrvc: PagerService, private _validationSrvc: ValidationService
    ) {
        this.mainComponent=_mApp;
    }

    ngOnInit() {
        this.pager.pageSize =localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;;
        this.pager.pageIndex = 0;
        this.pager.pageSizeOptions = this._pageSrvc.pageSizeOptions;
        this.SetPage(this.pager);
        this.GetUnits();
        this.CreateForm();
        this.testMethodsSearchForm = this._formBuilder.group({
            Name: ['',]
        });

    }

    CreateForm() {
        this.testMethodsForm = this._formBuilder.group({
            TestMethodId: [0],
            Name: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(50)])],
            TestMethodCode: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(50)])],
            UnitId: [''],
            VersionName:['',Validators.compose([Validators.minLength(1),Validators.maxLength(50)])],
            Description: ['',Validators.compose([ Validators.minLength(3), Validators.maxLength(250)])]
        });
    }

    GetUnits() {
        this._http.get(this._appUrl.GetUnitsForDDL)
            .subscribe(
            data => {
                if (data.json().Result != null) {
                    this.units = data.json().Result;
                }
            },
            error => {
                this._toaster.error(error.json().Result, '')
            }
            )
    }

    SetPage(page: any) {        
        this.pager.pageSize=page.pageSize;
        this.pager.pageIndex=page.pageIndex;
        this.GetTestMethodsList(this.pager);
    }

    GetTestMethodsList(page: any) {
        this._mApp.ShowLoader();
        this.searchFields.PageNo = page.pageIndex;
        this.searchFields.PageSize = page.pageSize;
        this._http.post(this._appUrl.GetTestMethodList, this.searchFields)
            .subscribe(
            data => {
                this._mApp.HideLoader();
                var response = data.json();
                this.pagedItems = response.Result;
                this.length = response.PageResult.TotalRecords;
                this.isNoRecords = !(response.Result.length > 0)
            },
            error => {
                this._mApp.HideLoader();
                this._toaster.error(error.json().Result);
            }
            )
    }

    GetTestMethodsById(id: number) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetTestMethodDetails + id)
            .subscribe(
            m => {
                this._mApp.HideLoader();
                if (m.json().Result != null) {
                    this.testMethodsForm.setValue(m.json().Result);
                    this.FetchUpdatedData();
                }
            }, error => {
                this._mApp.HideLoader();
                this._toaster.error(error.json().Result, '');
            }
            )
    }

    DeleteTestMethod(id) {
        this.id = id;
    }

    DeleteTestMethodById(id) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.DeleteTestMethod + id)
            .subscribe(
            data => {
                this._mApp.HideLoader();
                this._toaster.success(data.json().Result, '');
                this.SetPage(this.pager)
            },
            error => {
                this._mApp.HideLoader();
                this._toaster.error(error.json().Result, '')
            }
            )
    }
     FetchUpdatedData()
    {
        this.GetUnits();
    }

    onSubmit() {
        this.isSubmitted = true;
        if (this.testMethodsForm.valid) {
            this._mApp.ShowLoader();
            let val = this.testMethodsForm.value;
            if(val.TestMethodId==null||val.TestMethodId==0)
            {
                val.TestMethodId=0;
            }
            this._http.post(this._appUrl.AddEditTestMethod, val)
                .subscribe(
                data => {
                    this._mApp.HideLoader();
                    this._toaster.success(data.json().Result);
                    $("#addTestMethodsModel").modal('toggle');
                    this.Clear();
                    this.SetPage(this.pager);
                },
                error => {
                    this._mApp.HideLoader();
                    this._toaster.error(error.json().Result);
                }
                )
        }
    }

    onSearchSubmit() {
        this.pager.pageIndex = 0;
        let search = this.testMethodsSearchForm.value;
        this.searchFields.Name = search.Name;
        this.SetPage(this.pager);
    }

    Clear() {
        this.testMethodsForm.reset();
        //this.CreateForm();
    }

    OnReset() {
        this.testMethodsSearchForm.reset();
        this.searchFields.Name = '';
        this.pager.pageSize=this._mApp.pageSize;
        this.pager.pageIndex=0;
        this.FetchUpdatedData();
        this.SetPage(this.pager);
    }
}
